<template>
  <v-content>
    <v-container>
      <v-card class="elevation-12">
        <v-card-text>
          <div v-if="numeric">
            <vue-keyboard
              class="keyboardNumeric"
              @bs="custom('backspace')"
              @enter="custom('enter')"
              @input="changed"
              layouts="123|456|789|{←:bs}0{Ok:enter}"
            ></vue-keyboard>
          </div>
          <div v-else>
            <vue-keyboard
              class="keyboardFull"
              @bs="custom('backspace')"
              @enter="custom('enter')"
              @input="changed"
              layouts="1234567890{←:bs}|йцукенгшщзхъ|фывапролджэё|{____:sp}ячсмитьбю{Enter:enter}"
            ></vue-keyboard>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
  <!--<vue-keyboard-->
  <!--v-model="badgeBarcode"-->
  <!--:layouts="[-->
  <!--'1234567890{delete:backspace}|qwertyuiop|asdfghjkl|{shift:goto:1}zxcvbnm|{space:space}{custom:custom}',-->
  <!--'!@#$%^&*(){delete:backspace}|QWERTYUIOP|ASDFGHJKL|{shift:goto:0}ZXCVBNM|{space:space}{custom:custom}'-->
  <!--]"-->
  <!--:maxlength="16"-->
  <!--&gt;</vue-keyboard>-->
</template>

<script>
export default {
  name: 'VirtualKeyboard',
  props: {
    numeric: {
      type: Boolean,
    },
  },
  components: {
    'vue-keyboard': () => import('vue-keyboard'),
  },
  methods: {
    changed(value) {
      this.$emit('key', value)
    },
    custom(keyCode) {
      this.$emit('key', keyCode)
    },
  },
}
</script>

<style scoped lang="scss">
@import '../_scss/main';

.v-content {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 10;
  width: auto;
  max-width: none;
  padding: 0 !important;
  /deep/ .v-content__wrap {
    padding: 0;
    > .container {
      @include xxs {
        padding: 0;
      }
    }
  }
  /deep/ .container {
    width: auto;
  }
  /deep/ .vue-keyboard-row {
    display: flex;
    justify-content: center;
    @include sm {
    }
  }
  /deep/ .keyboardNumeric > .vue-keyboard-key {
    @include sm {
      padding: 6px;
      width: 60px;
      height: 35px;
      font-size: 20px;
      font-weight: bold;
    }
    @include xxs {
      padding: 4px;
      min-width: 15px;
    }
  }
  /deep/ .keyboardFull > .vue-keyboard-key {
    @include sm {
      padding: 5px;
      width: 10px;
      height: 10px;
      font-size: 10px;
      font-weight: bold;
    }
    @include xxs {
      padding: 4px;
      min-width: 15px;
    }
  }
}
</style>
